import { WorkPlace as WorkPlaceResponse } from '@/DTOS/WorkPlace/Response/WorkPlace';
import { EditOutlined, FileSearchOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React from 'react';

export const WorkPlaceColumn = (
  handleEdit: (record: WorkPlaceResponse) => void,
  handleModalInformationOpen: (record: WorkPlaceResponse) => void
) => [
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Client',
    dataIndex: ['company', 'name'],
    key: 'companyName',
    render: (text: string) => (
      <Tooltip title={text}>
        <div className='ellipsis-cell'>{text}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Denumire',
    dataIndex: 'name',
    key: 'name',
    render: (text: string) => (
      <Tooltip title={text}>
        <div className='ellipsis-cell'>{text}</div>
      </Tooltip>
    ),
  },

  {
    title: 'Adresa',
    dataIndex: 'address',
    key: 'address',
    render: (text: string) => (
      <Tooltip title={text}>
        <div className='ellipsis-cell'>{text}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Detalii',
    dataIndex: 'details',
    key: 'details',
    width: 200,
    render: (record: string | undefined) => (
      <Tooltip title={record}>
        <div className='ellipsis-cell'>{record ? record : '-'}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Actiune',
    key: 'actions',
    render: (record: WorkPlaceResponse) => (
      <div className='action-column' style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Tooltip title='Modifica'>
          <Button className='modify-button' icon={<EditOutlined />} onClick={() => handleEdit(record)} />
        </Tooltip>
        <Tooltip title='Informatii'>
          <Button
            className='info-button'
            icon={<FileSearchOutlined />}
            onClick={() => handleModalInformationOpen(record)}
          />
        </Tooltip>
      </div>
    ),
    width: 150,
    fixed: 'right',
  },
];
